export type RatingScale = '1-5' | '1-10';

export type QuestionOptions = {
  length: number;
  scale: RatingScale;
  startLabel: string;
  endLabel: string;
};

export enum QuestionKind {
  Boolean = 'boolean',
  Dropdown = 'dropdown',
  File = 'file',
  Info = 'info',
  MultipleChoice = 'multi_choice',
  ScaleRating = 'scale_rating',
  Scorecard = 'scorecard',
  SingleChoice = 'single_choice',
  String = 'string',
  Text = 'text',
  Video = 'video',
}
